/**
 * Types of admin tasks that can be managed
 */
export enum ETaskType {
  /** Selfie, T-shirt, Shoes approval */
  KIT_CHECK = "KIT_CHECK",
  /** Sessions not started/completed */
  UNATTENDED_SESSION = "UNATTENDED_SESSION",
  /** Sessions without partners */
  UNASSIGNED_SESSION = "UNASSIGNED_SESSION",
  /** Incomplete sessions pending review */
  INCOMPLETE_SESSION = "INCOMPLETE_SESSION",
  /** Partner base pay approvals */
  PARTNER_BASE_PAY = "PARTNER_BASE_PAY",
  /** Payout approvals */
  PARTNER_PAYOUT = "PARTNER_PAYOUT",
  /** Penalty approvals */
  PARTNER_PENALTY = "PARTNER_PENALTY",
  /** Training completion approvals */
  PARTNER_TRAINING = "PARTNER_TRAINING",
  /** Aadhar, PAN, Cheque approvals */
  PARTNER_KYC = "PARTNER_KYC",
  /** Onboarding kit payment marking */
  KIT_ORDER = "KIT_ORDER",
  /** Partner activation approvals */
  PARTNER_ACTIVATION = "PARTNER_ACTIVATION",
  /** Mark approved payouts as paid */
  PARTNER_PAYOUT_PAYMENT = "PARTNER_PAYOUT_PAYMENT",
  /** External PAN/Bank verification (no images) - v2 onboarding */
  PARTNER_KYC_2026_03 = "PARTNER_KYC_2026_03",
  /** Mark joining fee as paid (EXTERNAL vendor) - v2 onboarding */
  JOINING_FEE_MARK_PAID_2026_03 = "JOINING_FEE_MARK_PAID_2026_03",
  /** Grooming training approval with images - v2 onboarding */
  TRAINING_GROOMING_2026_03 = "TRAINING_GROOMING_2026_03",
  /** Customer refund request approvals */
  REFUND_REQUEST = "REFUND_REQUEST",
}

/**
 * Status of an admin task
 */
export enum ETaskStatus {
  /** Awaiting action */
  PENDING = "PENDING",
  /** Approved by admin */
  APPROVED = "APPROVED",
  /** Rejected by admin */
  REJECTED = "REJECTED",
  /** Cancelled/no longer relevant */
  CANCELLED = "CANCELLED",
  /** Automatically approved by system */
  AUTO_APPROVED = "AUTO_APPROVED",
}

/**
 * Actions that can be performed on admin tasks
 */
export enum ETaskAction {
  /** Approve the task */
  APPROVE = "APPROVE",
  /** Reject the task */
  REJECT = "REJECT",
  // Future: ESCALATE, DEFER, etc.
}

/**
 * Types of items in a kit check
 */
export enum EKitCheckItemType {
  SELFIE = "SELFIE",
  T_SHIRT = "T_SHIRT",
  SHOES = "SHOES",
}
